export default "__VITE_ASSET__z$CBoAP9__"